import { getFilesByMuestraId } from "../api/Muestras/muestraApi";
import {
  getCachedArchivos,
  setCachedArchivos,
} from "./cacheArchivos";

const inFlight = new Map();

/**
 * Lista archivos de muestra con cache en memoria y deduplicación de peticiones.
 * Tras el primer resultado (vacío o con ficheros) no vuelve a llamar al API para ese id.
 */
export async function fetchMuestraFilesCached(muestraId) {
  const id = Number(muestraId);
  if (!Number.isFinite(id)) return [];

  const cached = getCachedArchivos(id);
  if (cached !== undefined) return cached;

  if (inFlight.has(id)) {
    return inFlight.get(id);
  }

  const promise = getFilesByMuestraId(id)
    .then((data) => {
      const files = Array.isArray(data) ? data : [];
      setCachedArchivos(id, files);
      return files;
    })
    .catch((err) => {
      if (err?.response?.status !== 404) {
        console.error("Error loading archivos:", err);
      }
      setCachedArchivos(id, []);
      return [];
    })
    .finally(() => {
      inFlight.delete(id);
    });

  inFlight.set(id, promise);
  return promise;
}
